import { Component, Input, OnDestroy } from '@angular/core';
import { BaseValidationSummary, BuilderRequest, ValidationSummaryClass } from 'src/app/models/requests';
import { Workflow } from 'src/app/models/workflow';
import { RequestBuilderService } from '../request-builder.service';
import { Subscription } from 'rxjs';


// TAB NAMES
export const Document_TabName = "AddDocuments";
export const Person_TabName = "AddPersons";
export const Action_TabName = "AddActions";
export const Final_TabName = "ReviewAndSend";

@Component({
  selector: 'app-requestheader',
  templateUrl: './requestheader.component.html'
})
export class RequestHeaderComponent implements OnDestroy {


  public currentTab: string = Document_TabName;// "AddDocuments";

  @Input() request!: BuilderRequest;
  @Input() workflowData!: Workflow;

  workflowSteps: string[] = [];
  /**
   * BIG COMPLETE VALIDATION SUMMARY
   */
  public completeValidationSummary: ValidationSummaryClass | null = null;

  // WHETHER YOU CLICKED THE APPROPIATE BUTTONS (NEXT)
  public clicked_Document_Next_Button: boolean = false;
  public clicked_Person_Next_Button: boolean = false;
  public clicked_Action_Next_Button: boolean = false;
  public clicked_SendGroup_Next_Button: boolean = false;


  // WHETHER TO DISPLAY THE VALIDATION MESSAGES ON A TAB
  public get displayError_Tab_Documents() {
    return this.clicked_Document_Next_Button && !this.getSummaryForTab(Document_TabName)?.passedValidations && this.currentTab == Document_TabName;
  }
  public get displayError_Tab_Persons() {
    return this.clicked_Person_Next_Button && !this.getSummaryForTab(Person_TabName)?.passedValidations && this.currentTab == Person_TabName;
  }
  public get displayError_Tab_Actions() {
    return this.clicked_Action_Next_Button && !this.getSummaryForTab(Action_TabName)?.passedValidations && this.currentTab == Action_TabName;
  }
  public get displayError_Tab_SendGroups() {
    // always display if present
    return this.currentTab == Final_TabName;
  }

  // WHETHER TO MARK THE NUMBER CIRCLE RED
  public get markError_Tab_Documents() {
    return this.clicked_Document_Next_Button && this.getSummaryForTab(Document_TabName)?.hasValidationErrors;
  }
  public get markError_Tab_Persons() {
    return this.clicked_Person_Next_Button && this.getSummaryForTab(Person_TabName)?.hasValidationErrors;
  }
  public get markError_Tab_Actions() {
    return this.clicked_Action_Next_Button && this.getSummaryForTab(Action_TabName)?.hasValidationErrors;
  }
  public get markError_Tab_SendGroups() {
    // always display if present
    return this.getSummaryForTab(Final_TabName)?.hasValidationErrors;
  }


  // WHETHER TO MARK THE HEADER AS ACTIVE/AVAILABLE FOR CLICKING/NAVIGATION:
  // these build upon eachother:
  public get available_Tab_Documents() {
    // FIRST IS ALWAYS enabled
    return true;
  }
  public get available_Tab_Persons() {
    return this.available_Tab_Documents && this.getSummaryForTab(Document_TabName)?.passedValidations;
  }
  public get available_Tab_Actions() {
    return this.available_Tab_Persons && this.getSummaryForTab(Person_TabName)?.passedValidations;
  }
  public get available_Tab_SendGroups() {
    return this.available_Tab_Actions && this.getSummaryForTab(Action_TabName)?.passedValidations;
  }


  // subscriptions
  currentTabSubscription: Subscription | null = null;
  workflowStepsSubscription: Subscription | null = null;
  validationSummarySubscription: Subscription | null = null;

  constructor(private requestBuilderService: RequestBuilderService) {
    this.currentTabSubscription = this.requestBuilderService.currentTab$.subscribe(currentTab => {
      this.currentTab = currentTab;
    });
    this.workflowStepsSubscription = this.requestBuilderService.workflowSteps$.subscribe(steps => {
      this.workflowSteps = steps;
    });
    this.validationSummarySubscription = this.requestBuilderService.validationSummary$.subscribe((summary) => {
      this.completeValidationSummary = summary;
    });
  }

  ngOnDestroy(): void {
    if (this.currentTabSubscription) {
      this.currentTabSubscription.unsubscribe();
    }
    if (this.workflowStepsSubscription) {
      this.workflowStepsSubscription.unsubscribe();
    }
    if (this.validationSummarySubscription) {
      this.validationSummarySubscription.unsubscribe();
    }
  }

  /**
   * Sets the input as the New Current selected Tab
   * @param newTabName
   */
  setNewTabAsActive(newTabName: string) {
    this.requestBuilderService.changeCurrentTab(newTabName);
    if (newTabName === Action_TabName) {
      this.requestBuilderService.mergeSendgroups();
    }
  }

  /**
   * WHAT happens when the tob header thingie is clicked, per desired TAB:
   * @param clickedTab 
   */
  tabOrbsClicked(clickedTab: string) {
    // skip disabled tabs, do not trigger/set their buttons: 
    if (this.disableTabOrb(clickedTab)) {
      return;
    }
    // you can ALWAYS navigate to Documents
    if (clickedTab == Document_TabName) {
      this.clicked_Document_Next_Button = true;
      this.setNewTabAsActive(clickedTab);
    }

    // when navigating TO Person:
    if (clickedTab == Person_TabName) {
      // technically you try this:
      this.clicked_Document_Next_Button = true;
      // if invalid documents, not allowed:
      if (!this.completeValidationSummary?.documentValidationSummary.passedValidations) {
        return;
      } else {
        this.setNewTabAsActive(clickedTab);
        return;
      }
    }

    // when navigating TO Actions:
    if (clickedTab == Action_TabName) {
      // technically you try this:
      this.clicked_Person_Next_Button = true;
      // if invalid Persons, not allowed:
      if (!this.completeValidationSummary?.personValidationSummary.passedValidations && !this.workflowData?.step2?.skipStep) {
        return;
      } else {
        this.setNewTabAsActive(clickedTab);
        return;
      }
    }
    // when navigating TO SendGroups/Final:
    if (clickedTab == Final_TabName) {
      // technically you try this:
      this.clicked_Action_Next_Button = true;
      // if invalid Actions, not allowed:
      if (!this.completeValidationSummary?.actionValidationSummary.passedValidations && !this.workflowData?.step3?.skipStep) {
        return;
      } else {
        this.setNewTabAsActive(clickedTab);
        return;
      }
    }
  }

  /**
   * WHAT happens when NEXT BUTTON is clicked, per TAB:
   */
  nextButtonClicked() {
    switch (this.currentTab) {
      case Document_TabName: {
        this.clicked_Document_Next_Button = true;
        if (!this.completeValidationSummary?.documentValidationSummary.passedValidations) {
          return;
        }
        break;
      }
      case Person_TabName: {
        this.clicked_Person_Next_Button = true;
        if (!this.completeValidationSummary?.personValidationSummary.passedValidations) {
          return;
        }
        break;
      }
      case Action_TabName: {
        this.clicked_Action_Next_Button = true;
        if (!this.completeValidationSummary?.actionValidationSummary.passedValidations) {
          return;
        }
        break;
      }
      case Final_TabName: {
        this.clicked_SendGroup_Next_Button = true;
        if (!this.completeValidationSummary?.sendGroupValidationSummary.passedValidations) {
          return;
        }
        break;
      }
      default: {
        break;
      }
    }
    let titleIndex = this.workflowSteps?.findIndex(s => s === this.currentTab);
    if (this.currentTab === Action_TabName) {
      this.requestBuilderService.mergeSendgroups();
    }
    if (titleIndex < this.workflowSteps.length) {
      this.setNewTabAsActive(this.workflowSteps[titleIndex + 1]);
    }
  }

  /**
   * what happens when PREVIOUS BUTTON is clicked, per TAB:
   */
  previousButtonClicked() {
    let titleIndex = this.workflowSteps?.findIndex(s => s === this.currentTab);
    if (titleIndex < this.workflowSteps?.length) {
      this.setNewTabAsActive(this.workflowSteps[titleIndex - 1]);
    }
  }

  /**
   * Grab the appropiate summary per TAB:
   * @param forTab 
   * @returns .........any...... yep...
   */
  getSummaryForTab(forTab: string): BaseValidationSummary | undefined | null {
    switch (forTab) {
      case Document_TabName: {
        return (this.completeValidationSummary?.documentValidationSummary);
      }
      case Person_TabName: {
        return (this.completeValidationSummary?.personValidationSummary);
      }
      case Action_TabName: {
        return (this.completeValidationSummary?.actionValidationSummary);
      }
      case Final_TabName: {
        return (this.completeValidationSummary?.sendGroupValidationSummary);
      }
      default: {
        return this.completeValidationSummary;
      }
    }
  }

  /**
   * WHETHER the matching ORB should be DISABLED:
   * @param tabName tab name to compare whether its 'Header orb' would be enabled:
   * @returns  TRUE if given Tab name would be disabled
   */
  disableTabOrb(tabName: string): boolean {
    var disabled = true;
    var enabled = false;
    // NEVER DISABLED
    if (tabName == Document_TabName) {
      return enabled;
    }
    // ALWAYS DISABLED
    if (!this.completeValidationSummary) {
      return disabled;
    }
    if (this.workflowSteps) {
      var indexOfMe = this.workflowSteps.indexOf(tabName);
      if (this.workflowSteps[indexOfMe - 1]) {
        if (this.getSummaryForTab(this.workflowSteps[indexOfMe - 1])?.passedValidations) {
          return enabled;
        }
      }
    }

    return disabled;
  }

  /**
   * WHETHER THE NEXT BUTTON SHOULD BE DISABLED:
   * allows a first time click, than locks it if validations not passed:
   * @returns TRUE if previous is disabled FOR CURRENT TAB
   */
  disableNextButton(): boolean {
    if (!this.completeValidationSummary) {
      return true;
    }
    if (this.workflowSteps) {
      if (this.currentTab == this.workflowSteps[this.workflowSteps.length - 1]) {
        return true;
      }
    }
    switch (this.currentTab) {
      case Document_TabName: {
        return (this.clicked_Document_Next_Button && !this.getSummaryForTab(this.currentTab)?.passedValidations);
      }
      case Person_TabName: {
        return (this.clicked_Person_Next_Button && !this.getSummaryForTab(this.currentTab)?.passedValidations);
      }
      case Action_TabName: {
        return (this.clicked_Action_Next_Button && !this.getSummaryForTab(this.currentTab)?.passedValidations);
      }
      case Final_TabName: {
        // last is always disabled
        return true;
      }
      default: {
        return true;
      }
    }

  }

  /**
   * WHETHER THE PREVIOUS BUTTON IS ALLOWED TO CLICK:
   * @returns TRUE if previous is disabled FOR CURRENT TAB
   */
  disablePreviousButton(): boolean {
    // first tab is always DISABLED
    if (this.currentTab === this.workflowSteps[0]) {
      return true;
    }
    // otherwise always an option
    return false;
  }
}
